<div class="container" fxLayout="column" fxLayoutGap="20px">
  <div fxLayout="column" fxLayoutAlign="center center" class="icon-container">
    <mat-icon>vpn_key</mat-icon>
  </div>
  <h2 class="fs-18px mb-10">{{ 'keywords.enter_the_verification_code' | translate }}:</h2>
  <app-input label="Verification" [formControl]="verificationCode" [controlType]="'number'" [minlength]="6"></app-input>
  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-between center">
    <button class="medium-button-white" fxFlex="50" mat-button (click)="closeDialog()">
      {{ 'keywords.cancel' | translate }}
    </button>
    <button class="medium-button-blue" fxFlex="50" mat-button [disabled]="verificationCode.invalid" (click)="proceed()">
      Ok
    </button>
  </div>
</div>
